export default __webpack_public_path__ + "0d12d18a13b8fcefa4b33c13f02c6054.jpg";